import { render, staticRenderFns } from "./SuperTalkCommunity.vue?vue&type=template&id=85c1d274&scoped=true"
import script from "./SuperTalkCommunity.vue?vue&type=script&lang=js"
export * from "./SuperTalkCommunity.vue?vue&type=script&lang=js"
import style0 from "./SuperTalkCommunity.vue?vue&type=style&index=0&id=85c1d274&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "85c1d274",
  null
  
)

export default component.exports